var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"missing"}},[_c('div',{staticClass:"g-right-top width800"},[_vm._v("个人中心／编辑资料／基本信息")]),_vm._v(" "),_c('div',{staticClass:"g-right-middle width800 margintop20"},[_c('div',{staticClass:"bg-qsy"}),_vm._v(" "),_c('div',{staticClass:"g-add-btn"},[_c('router-link',{attrs:{"to":"/per_admin/edit/jbxx"}},[_vm._v("完善信息")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7e7a506","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/per_admin/P_Missing.vue
// module id = null
// module chunks = 